import { DisplayLocale } from "../../../lib/Money.ts";
import {
    ChatHistoryGroup,
    CHAT_HISTORY_GROUP_ORDER,
    DAY_MS,
    QuinnCopy,
} from "../types";

export { CHAT_HISTORY_GROUP_ORDER };

export function resolveChatHistoryGroup(updatedAt: string, now: Date = new Date()): ChatHistoryGroup {
    const updated = new Date(updatedAt);
    if (Number.isNaN(updated.getTime())) return ChatHistoryGroup.Earlier;

    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    const updatedMs = updated.getTime();

    if (updatedMs >= startOfToday) return ChatHistoryGroup.Today;
    if (updatedMs >= startOfToday - DAY_MS) return ChatHistoryGroup.Yesterday;
    if (updatedMs >= startOfToday - 7 * DAY_MS) return ChatHistoryGroup.ThisWeek;
    return ChatHistoryGroup.Earlier;
}

export function formatChatTimestamp(updatedAt: string, now: Date = new Date()): string {
    const updated = new Date(updatedAt);
    if (Number.isNaN(updated.getTime())) return "";

    const diffMinutes = Math.round((now.getTime() - updated.getTime()) / 60_000);
    if (diffMinutes < 1) return QuinnCopy.JustNow;
    if (diffMinutes < 60) return `${diffMinutes}m`;

    const isToday = updated.toDateString() === now.toDateString();
    if (isToday) {
        return updated.toLocaleTimeString(DisplayLocale.NL_NL, { hour: "2-digit", minute: "2-digit" });
    }

    return updated.toLocaleDateString(DisplayLocale.NL_NL, { day: "numeric", month: "short" });
}
